type EventLocationProps = {
    displayName: string;
    locationType: string;
    uniqueIdType: string;
    latitude?: number;
    longitude?: number;
};

export default class EventLocation {
    displayName: string;

    locationType: string;

    uniqueIdType: string;

    latitude?: number;

    longitude?: number;

    constructor({
        displayName,
        locationType,
        uniqueIdType,
        latitude,
        longitude,
    }: EventLocationProps) {
        this.displayName = displayName;
        this.locationType = locationType;
        this.uniqueIdType = uniqueIdType;
        this.latitude = latitude;
        this.longitude = longitude;
    }
}
